<template>
  <div>
    <b-link
        style="color:#FFC729FF"
        @click="handleCreateACarePlanClick">
    + Create A Care Plan
    </b-link>
    <modal
        :ref="modalId"
        :id="modalId"
        size="lg"
        @show="handleModalToBeShown"
    >
      <div class="add-edit-care-plan" v-if="!del">
        <close-button
        class="close-icon"
        @close-button-click="hideModal"
        />
        <h3>{{ formAdd ? "Create" : "Edit" }} Care Plan</h3>
        <template v-if="formCarePlan && formCarePlan.title">
          <h6> for {{ formCarePlan.title }}</h6>
        </template>
        <div class="h-18"></div>
        <b-tabs defaultActiveKey="generalInfo" content-class="mt-3">
          <b-tab
              v-for="(aSection, index) in availSections"
              :key="index"
              :title="aSection.title"
          >
            <component
                :is="aSection.component"
                v-bind="Object.assign({}, propsData)"
                :ref="aSection.componentName"
                @value-change="handleValueChange"
                @reset-click="handleResetClickofTabId(aSection.id)"
            >
            </component>
          </b-tab>
        </b-tabs>
        <div class="foot">
          <div class="d-flex justify-content-between">
            <b-button
                v-if="formAdd"
              style="width: 100%;"
              variant="primary"
              @click="handleAddCarePlanButtonClick"
              :disabled="!canAdd"
            >
              Add
            </b-button>
            <b-button
                v-else
              style="width:100%"
              variant="primary"
              @click="handleUpdateCarePlanClick"
              :disabled="!canUpdate"
            >
              Update
            </b-button>
          </div>
        </div>
      </div>
      <div class="add-edit-care-plan del-care-plan" v-else>
        <span class="close-icon" @click="$bvModal.hide(carePlanModalId)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="10.6667"
                  height="10.6667"
                  fill="white"
                  transform="translate(6.6665 6.66675)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h3>Delete Care Plan</h3>
        <div class="warning-msg">
          <p>
            Are you sure want to delete
            <strong>{{ plans[this.activeIndex].title }}</strong>
            plan?
          </p>
        </div>
        <div class="d-flex justify-content-between">
          <b-button class="danger btn-round-fill" @click="deletePublishing">
            Yes! Delete
          </b-button>
          <b-button class="btn-simple" @click="hideDeletePublishing">
            No! back
          </b-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import Modal from "@/components/common/modal";
import socialsMixin from "@/mixins/Socials";
import CloseButton from "@/components/common/closeButton";
//Tabs
import GeneralInfo from "./generalInfo";
import CompanyInfo from "./companyInfo";
import CareAreas from "./careAreas";
import Overrides from "./overrides";
import Simulation from "./simulation";

import CarePlanAgenda from "./agenda";
import CarePlanNotifications from "./notifications";


export default {
  name: "AddEditCarePlanModal",
  mixins: [socialsMixin],
  components: {
    Modal,
    CloseButton
  },
  props: {
    modalId: {
      type: String,
      default: "add-edit-care-plan-provider"
    },
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    carePlan: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    rootPathDoc: {
      type: String,
      default: null
    }
  },
  beforeMount() {},
  mounted() {
    this.resetForm();
    this.fetching = false;
    this.setRolesArray();
    //this.$store.dispatch("user/getListNames");
    //this.$store.dispatch("user/getListRoles");
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      plans: "user/listPublishings",
      getLocalPublishingWithId: "user/getLocalPublishingWithId",
    }),
    canAdd() {
      return this.formCarePlan && this.formCarePlan.heartbeat && this.formCarePlan.heartbeat.firstname
        && this.formCarePlan.heartbeat.firstname.trim().length > 0
          ? true : false;
    },
    canEditPrimary() {
      return this.activeCarePlanStatus === "draft" || this.formAdd
        ? true
        : false;
    },
    canEditSecondary() {
      return this.activeCarePlanStatus !== "inactive" &&
        this.activeCarePlanStatus !== "submitted"
        ? true
        : false;
    },
    canUpdate() {
      return true;
      return this.formCarePlan.firstname &&
        this.formCarePlan.title.trim().length > 0 &&
        this.activeCarePlanStatus !== "inactive"
        ? true
        : false;
    },
    currentPublishing() {
      return this.publishings && Array.isArray(this.publishings)
        ? this.publishings.filter(aPublishing => {
            return aPublishing.id === this.planId;
          })[0]
        : null;
    },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        form: this.formCarePlan
      };
    }
  },
  methods: {
    handleCreateACarePlanClick(){
      this.formAdd = true;
      this.resetForm();
      this.$bvModal.show(this.modalId);
    },
    handleValueChange({key, value}) {
      let subKeys = key ? key.split("."): null;

      if (Array.isArray(subKeys)){
        if(subKeys.length == 2) {
          this.formCarePlan[subKeys[0]][subKeys[1]] = value;
        } else{
          this.formCarePlan[subKeys[0]] = value;
        }
      }
    },
    handleResetClickofTabId(sectionId){
      switch (sectionId) {
        case "companyInfo":
          this.handleSetCompanyProfileDefault();
          break;
        default:
          break
      }
    },
    /**** ADD SESSION **/
    handleAddCarePlanButtonClick() {
      this.addCarePlan()
          .then((carePlan)=> {
           //delete this.$emit("care-plan-created");
            this.$bvModal.hide(this.modalId);
            this.resetForm();
          }).catch((error)=>{
            console.error(error);
      });
    },
    addCarePlan() {
      debugger;
      return new Promise((res, rej) => {
        let planId = `careplan_${this.generateCarePlanId(20)}`;
        let planPayload = {
          id:  planId,
          _created_at: new Date(),
          status: "draft",
          plan: this.formCarePlan
        }
        this.$store
            .dispatch("service/addCarePlan", {
              rootPathDoc: this.rootPathDoc,
              plan: planPayload})
            .then(resp => {
              if (resp) {
                this.$store.dispatch("user/showNotification", {
                  title: `${planPayload.title} added successfully`,
                  description: "The Care Plan has been added",
                  variant: "success"
                });
                res(planPayload);
              }
            })
            .catch(error => {
              this.$store.dispatch("user/showNotification", {
                title: `${planPayload.title} could not be added`,
                description: `${error}`,
                variant: "warning"
              });
              rej(error);
            });
      });
    },
    /***** UPDATE SESSION **/
    handleModalToBeShown(){
      debugger;
      if(this.plan) { //this is an edit
        this.formCarePlan = _.clone(this.plan.session);
      }
    },
    generateCarePlanId(length) {
      //move to mixin
      var result = "";
      var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
      }
      const date = new Date().valueOf();
      return `${this.user.uid}_${result}_${date}`;
    },
    showEditCarePlan(planData) {
      debugger;
      if (planData.plan && planData.id) {
        this.formAdd = false;
        this.planDataId = planData.id;
        this.formCarePlan = planData.plan
        this.activeCarePlanStatus = planData.status;
        //temp crew
        this.createCrewMember({
          uid: this.profile.userId,
          name: `${this.profile.firstname} ${this.profile.lastname ? this.profile.lastname :''}`,
          imgURL: this.profile.imgURL
        });

        this.$nextTick(function () {
          this.$bvModal.show(this.modalId);
        });
      }
    },
    handleUpdateCarePlanClick() {
      debugger;
        this.$store.dispatch("service/updateCarePlan",
            {
              rootPathDoc: this.rootPathDoc,
              id: this.planDataId,
              plan: this.formCarePlan
            }
        ).then(res => {
          if (res) {
            this.$store.dispatch("user/showNotification", {
              title: `${this.formCarePlan.title} updated Successfully`,
              description: `Care Plan has been updated`,
              variant: "success"
            });
            //deletethis.$emit('care-plan-updated');
            this.$bvModal.hide(this.modalId);
            this.resetForm();
          }
        });
      },
    setNameinDB(namesToSave) {
      let n = {};
      this.$store
        .dispatch("user/addNames", {
          names: namesToSave.length > 0 ? namesToSave : []
        })
        .then(async nameswUid => {
          console.log("nameswUid => ", nameswUid);
          await nameswUid.map((el, index) => {
            el._names_numbers_places_id = el.uid;
            delete el.uid;
            el.order = index;
            return el;
          });
          return nameswUid;
        });
    },
    setRolesArray() {
      this.$typeAheadRolesData.forEach(e => this.rolesArray.push(e.text));
    },
    resetClear() {
      this.clear = false;
    },
    input(val) {
      this.formCarePlan.description = val.content;
    },
    inputAbout(val) {
      this.formCarePlan.about_intro.about = val.content;
    },
    inputIntro(val) {
      this.formCarePlan.about_intro.intro = val.content;
    },
    getStatus(status) {
      switch (status) {
        case "draft":
          return "Draft";
        case "submitted":
          return "Submitted";
        case "need_work":
          return "Needs Work";
        case "inactive":
          return "Removed";
        case "active":
          return "Published";
        default:
          return "Draft";
      }
    },
    getStatusColor(status) {
      if (status == "draft") {
        return "#C0C0C0";
      } else if (status == "submitted") {
        return "var(--theme-color)";
      } else if (status == "need_work") {
        return "#FFCC00";
      } else if (status == "inactive") {
        return "#FF0000";
      } else if (status == "active") {
        return "#4BB543";
      }
    },
    addTag() {
      if (this.seo && this.seo.trim() == "") return;
      this.formCarePlan.seo.unshift(this.seo);
      this.seo = "";
    },
    delTag(tag) {
      let index = this.formCarePlan.seo.indexOf(tag);
      if (index > -1) {
        this.formCarePlan.seo.splice(index, 1);
      }
    },
    toggleSpheres(e) {
      if (this.formCarePlan.spheres.includes(e)) {
        let index = this.formCarePlan.spheres.indexOf(e);
        this.formCarePlan.spheres.splice(index, 1);
      } else {
        this.formCarePlan.spheres.push(e);
      }
    },
    hideModal() {
      this.$bvModal.hide(this.modalId);
    },
    cancelAction() {
      this.resetForm();
      this.refresh++;
    },
    resetForm() {

      this.formCarePlan = null;
      this.formCarePlan =_.clone(this.formCarePlanDefault);

      this.createCrewMember({
        uid: this.profile.userId,
        name: `${this.profile.firstname} ${this.profile.lastname ? this.profile.lastname :''}`,
        imgURL: this.profile.imgURL
      });

      this.handleSetCompanyProfileDefault();

      //this.seo = "";
      //this.activeIndex = null;
      //this.activeCarePlanStatus = null;
    },
    handleSetCompanyProfileDefault(){
      let dashboardType = "guide";
      let profileType = "profileCompany";

      if (this.profile &&  this.profile._dashboards && this.profile._dashboards[dashboardType] &&
          this.profile._dashboards[dashboardType][profileType]) {
        let companyProfile =  this.profile._dashboards[dashboardType][profileType];
        this.updateCompanyProfile(
            {
              name: companyProfile.name ? companyProfile.name : null,
              imgURL: companyProfile.imgURL ? companyProfile.imgURL : null,
              email: companyProfile.email ? companyProfile.email : null,
              phone: companyProfile.phone ? companyProfile.phone : null,
              expertise: companyProfile.expertise ? companyProfile.expertise : null,
              bio: companyProfile.bio ? companyProfile.bio : null,
            }
        )
      }
    },
     createCrewMember({uid, name, imgURL}) {
       let crewMember ={
         uid:uid,
         name:name,
         imgURL:imgURL,
         position: "Senior VP",
         role:{
           isHost: true,
           isSpeaker: true,
           isAdmin: true
         }
       };
       this.formCarePlan.crew && !Array.isArray(this.formCarePlan.crew)
       this.formCarePlan.crew = [];
       this.formCarePlan.crew.push(crewMember);
     },
    updateCompanyProfile( {name, imgURL, email, phone, expertise, bio}) {
      if (this.formCarePlan.company){
        this.formCarePlan._udated_at = new Date();
      } else {
        this.formCarePlan._created_at = new Date();
      }
      this.formCarePlan.company = {
        name: name,
        imgURL: imgURL,
        email: email,
        phone: phone,
        expertise: expertise,
        bio: bio
      };

      this.formCarePlan = {... this.formCarePlan};
    },
    handleResouceBlocksClick() {
      this.$bvModal.show(this.modalIdResourcesBlocks);
    },
    updateResources(tools) {
      this.formCarePlan.tools = tools;
    },
    handleAddSocialLink(socials) {
      this.formCarePlan.socials = socials;
    },
    showCrew() {
      this.$bvModal.show(this.modalIdCrewBlocks);
    },
    handleSocialClick() {
      this.$bvModal.show(this.modalIdSocialsClick);
    },
    getSvg(type) {
      let social = this.$socials.filter(social => social.type == type);
      return social[0] ? social[0].svg : "";
    }
  },
  data() {
    return {
      formAdd: true,
      planDataId: null,
      formCarePlan: {},
      formCarePlanDefault: {
        heartbeat: {
          firstname:null,
          lastname:null,
          language:null,
          timezone:null,
          spiritual:null,
          political:null
        },
        fam: {
          firstname:null,
          lastname:null,
          relationTo:null,
          language:null,
          timezone:null,
          spiritual:null,
          political:null,
          email:null,
          phone:null,
        },
        imgURL: null,
        description: null,
        useCompanyInfo: null,
        notifications:[],
      },
      sections : [
        {
          id: "generalInfo",
          title: "General Info",
          component: GeneralInfo,
          componentName: "GeneralInfo",
          avail: true
        },
        {
          id: "careAreas",
          title: "Care Areas",
          component: CareAreas,
          componentName: "CareAreas",
          avail: true
        },
        {
          id: "companyInfo",
          title: "Company Info",
          component: CompanyInfo,
          componentName: "CompanyInfo",
          avail: true
        },
        {
          id: "simulation",
          title: "Simulation",
          component: Simulation,
          componentName: "Simulation",
          avail: true
        },
        {
          id: "overrides",
          title: "Overrides",
          component: Overrides,
          componentName: "Overrides",
          avail: true
        },
        {
          title: "Methodology",
          id: "agenda",
          component: CarePlanAgenda,
          componentName: "CarePlanAgenda",
          avail: true
        },
        {
          title: "Medical Records",
          id: "agenda",
          component: CarePlanAgenda,
          componentName: "CarePlanAgenda",
          avail: true
        },
        {
          title: "Notifications",
          id: "notifications",
          component: CarePlanNotifications,
          componentName: "CarePlanNotifications",
          avail: false
        }
      ],
      //Move tooltips to inputed data
      tooltipSVG: require("@/assets/svg/tooltip.svg"),
      closeSVG: require("@/assets/svg/close.svg"),
      formplusSVG: require("@/assets/svg/formplus.svg"),
      sessToolTip : {
        titleTip:
            'Enter the main title as it appears on the cover and title page. The title should be the same on the paperback, hardcover, and ebook. Do not include any subtitle, series, edition, or format information in this field. For example: "Publishing 101: Everything You Need to Know", Publishing 101 is the title and Everything You Need to Know is the subtitle.',
        topicTip:
            'A subtitle is often a descriptive or explanatory title. Enter the subtitle as it would appear on the cover or title page. Keep subtitles succinct so as not to lose a potential buyer\'s attention. For example: "Publishing 101: Everything You Need to Know," Publishing 101 is the title and Everything You Need to Know is the subtitle.',
        descriptionTip:
            "Descriptive copy",
        publisherTip:
            " This is lookup table for your publisher. Leave blank is self-published.",
        pubISBNTip:
            "An ISBN (International Standard Book Number), also known as EAN (European Article Number), is a unique thirteen-digit item code provided by your country's ISBN agency and assigned by publishers to identify the format and edition of a particular title, required by retailers and distributors for sales and inventory purposes. An ebook will have a different ISBN or EAN than the print version of the same book. Read more about ISBNs.",
        pubRightsTip:
            "Choose this option if your book is under copyright and you hold the necessary rights for the content being published.",
        pubDomainWork:
            "Select this option if you are publishing a public domain book. Keep in mind that the duration of copyright varies between countries/regions. So, if your book is in the public domain in one country/region but not another, you must identify your territory rights accordingly",
        pubDateTip:
            "Enter the date on which your book was first published. Leave this blank if you are publishing your book for the first time.",
        pubPagesTip: "test",
        pubAdultContent:
            "Does this book contain language, situations, or images inappropriate for children under 18 years of age?- Your publication date is the date on which your book was first published. You cannot change it after publishing your title. If you leave this blank, HeartBeatFam will automatically use the date on which your book goes live (i.e. it is available for sale).",
        pubReviewsTip: "test",
        pubPriceTip: "test",
        pubSeriesTip:
            "Titles that feature an ongoing story, recurring character, or other organizing principle, such as theme or plot.",
        pubFormatTip: " test",
        pubCopyrightTip: " test",
      },
      modalIdResourcesBlocks: "block-resources",
      modalIdCrewBlocks: "block-crew",
      modalIdSocialsClick: "block-social",
      crew: [],
      planId: null,
      selectedPublishing: {},
      selectedPublishingId: null,
      fetching: false,
      refresh: 1,
      del: false,
      addedCrew: [],
      activeIndex: -1,
      activeCollapse: -1,
      clear: false,
      seo: "",
      asset: "",
      popupText: "Copy to clipboard",
      imgURL: "",
      rolesArray: [],
      languagesArray: this.$typeAheadAboutsLanguage,
      activeCarePlanStatus: null,
      activePublishing: null
    };
  },
};
</script>

<style lang="scss" scoped>
.publishing-foot {
  display: flex;
  justify-content: space-between;
  .stats {
    display: flex;
    align-items: center;
    .ico {
      margin: 0 17px;
    }
  }
  .collapse-foot {
    display: flex;
    justify-content: flex-end;
    .btn-simple-primary {
      background-color: #fff;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      justify-content: center;
      padding: 8px 16px;
      border: none;
      display: flex;
      letter-spacing: 0.05em;
      align-items: center;
      color: var(--theme-color);
      margin-left: 16px;
      border-radius: 4px;
      transition: all 0.2s ease-in-out;
      svg {
        margin-right: 16px;
      }
      &:hover {
        background-color: #f3f6f9;
      }
      &.btn-start {
        background-color: #f3f6f9;
        &:hover {
          background-color: #dfdfdf;
          box-shadow: 0px 0px 4px 0px #eee;
        }
      }
    }
  }
}

.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 25%;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-edit-care-plans {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-edit-care-plan {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3, h6 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    /*font-size: 24px;
    line-height: 33px;*/
    color: #474d52;
    text-align: center;
  }

}
.del-care-plan {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.publishings {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
      .ico {
        margin: 0 17px;
        cursor: pointer;
      }
      .doc-ico {
        margin-left: 0;
      }
      .doc-link {
        color: var(--theme-color);
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
    .status-btn {
      display: inline-block;
      margin-right: 15px;
      width: 105px;
      height: 21px;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      background: var(--theme-color);
      text-align: center;
      border: none;
      border-radius: 3px;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
    img {
      cursor: pointer;
      position: relative;
      // top: 50%;
      right: 4px;
      // -webkit-transform: translateY(-50%);
      // transform: translateY(-50%);
      height: 100px;
      width: 100px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      background: rgba(85, 126, 251, 0.1);
      border-radius: 8px;
    }
    .publishing-description {
      left: 5px;
    }
  }
}
.places-lived {
  margin-top: 26px;
  .place__places-lived {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    margin: 6px 15px;
  }
  .del__ico {
    cursor: pointer;
  }
}
.submit-btn {
  border-radius: 28px;
  width: 120px;
}
.roles {
  margin-top: 25px;
}
.resources {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.crew {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-crew {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.social {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.video-sec {
  margin-left: 15px;
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
.description-title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  max-width: 354px;
  width: 100%;
  margin: 18px 0;
  cursor: pointer;
}
.half-fields {
  margin-left: 3px;
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
}
</style>
